<template>

   <div class="componentRoot" style="display: flex; justify-content: center;">
    <v-container fluid id="loginPage" style=""> <v-row>
        <v-col :cols="loginCols" :class="paddingClass" style="display: flex; align-items: center; z-index: 5;">
         <v-form ref="registerForm" style="width: 100%" v-if="!registerDone">
            <v-container fluid style="background-color: rgb(var(--v-theme-light));" class="px-16">
            <v-row>
              <v-spacer />
              <v-col @click="goToLogin" style="cursor: pointer">
                <v-img :src="logo" style="width: 100%; height: 100%; max-height: 300px" />
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="firstName"
                  :label="$t('basics.firstName') + '*'"
                  :rules="[requiredRule, max256]"
                  variant="outlined"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="lastName"
                  :label="$t('basics.lastName') + '*'"
                  :rules="[requiredRule, max256]"
                  variant="outlined"
                ></v-text-field>
              </v-col>
            </v-row>
      
            <v-row>
              <v-col>
                <v-text-field
                  variant="outlined"
                  :label="$t('basics.email') + '*'"
                  v-model="email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row  @click="privacyAccpted = !privacyAccpted">
              <v-col cols="auto">
               <v-icon v-if="!privacyAccpted">mdi-checkbox-blank-outline</v-icon>
               <v-icon color="primary" v-else>mdi-checkbox-marked</v-icon>
              </v-col>
              <v-col>
                <div v-html="$t('messages.acceptPrivacySettings') + '*'"></div>
              </v-col>
            </v-row>

            <v-row>
              <v-col :cols="12" style="display: flex">
                <v-btn flat  @click="confirm" :loading="loading" :disabled="!privacyAccpted" class="primaryButton" large block>{{
                  $t("basics.register")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <div v-else  style="width: 100%">
            <v-container fluid style="background-color: rgb(var(--v-theme-light));" class="px-16">
            <v-row>
              <v-spacer />
              <v-col @click="goToLogin" style="cursor: pointer">
                <v-img :src="logo" style="width: 100%; height: 100%; max-height: 300px" />
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-col class="text-center">
                <h2>{{ $t("messages.registerDoneTitle") }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <h3 v-html="$t('messages.registerDoneMessage')"></h3>
              </v-col>
            </v-row>
            </v-container>
        </div>
        </v-col>
        <v-col :cols="mainCols" :style="{
          position: isMobile ? 'absolute' : 'block',
        }" style="left: 0; top: 0" class="pa-0">
          <img alt="Hintergrundbild Sonnenblumen" src="/images/main/background.jpeg" style="height: 100vh; object-fit: cover; width: 100%" />
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  data() {
    return {
      email: undefined,

      firstName: undefined,
      lastName: undefined,
      
      privacyAccpted: false,

      registerDone: false,

      loading: false,

      requiredRule: (v) => !!v || this.$t("messages.required"),
      emailRules: [
        (v) => !!v || this.$t("messages.required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("messages.wrongEMailFormat"),
      ],
      max256: (v) => v.length <= 256 || this.$t("messages.tooLong", { count: 256 }),
      max20: (v) => v.length <= 20 || this.$t("messages.tooLong", { count: 20 }),
      requiredArray: (v) => (!!v && v.length > 0) || this.$t("messages.required"),
    };
  },
  components: {
  },
  watch: {
    selectedOrganisations() {
      this.selectedCostCenter = undefined;
    },
  },
 
  computed: {
    resetURL() {
      return this.axios.defaults.url + "/accounts/password_reset/";
    },
    logo() {
      return "/logo_light.png";
    },
    isDarkTheme() {
      return this.$vuetify.theme.global.current.dark;
    },
    loginCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 5;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 7;
        case "xl":
          return 8;
        case "xxl":
          return 9;
        default:
          return 8;
      }
    },
    imageMaxHeigh() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "100px";
        case "sm":
          return "150px";
        default:
          return "200px";
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
      }
    },
    paddingClass() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "pa-0";
        case "sm":
          return "pa-4";
        case "md":
          return "pa-8";
        case "lg":
          return "pa-12";
        case "xl":
          return "pa-16";
        case "xxl":
          return "pa-16";
        default:
          return "pa-16";
      }
    },
  },


  methods: {
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
    goToLogin() {
      this.$router.push("/");
    },
    async confirm(){
      const {valid} = await this.$refs.registerForm.validate()

      if(valid){
        this.loading = true

        let formData = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
        }


        this.axios.post(this.axios.defaults.baseURL + "user/users/post/register/", formData)
        .then((resp) => {
          this.loading = false
          this.registerDone = true
        })
        .catch((e) => {
          this.loading = false
          console.log(e)
          window.dispatchEvent(new CustomEvent("showErrorDisplay", {detail: e}))
        })

      }
    }
  },
};
</script>
